import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { statusColor, statusLabel } from "@/lib/campaign-status";

interface EngagementStatusBadgeProps {
  status: string | null;
  className?: string;
}

// Thin renderer over the canonical status map (src/lib/campaign-status.ts).
// All colors/labels/aliases live there so this badge always agrees with the
// Hub status strip and CampaignDetail chips.
export function EngagementStatusBadge({ status, className }: EngagementStatusBadgeProps) {
  return (
    <Badge variant="secondary" className={cn(statusColor(status), className)}>
      {statusLabel(status)}
    </Badge>
  );
}
